import React, { FC } from 'react';

import { Typography } from '@material-ui/core';
import cx from 'classnames';
import parse from 'html-react-parser';

import { parseHighlightedText } from '../../utils/helpers';
import { CustomButton } from '../UI/CustomButton';
import useStyles from './styles';

interface QuoteItemProps {
  title?: string | null;
  subtitle?: string | null;
  isSingleItem?: boolean;
  highLightColor?: string | null;
  buttonLink?: string | null;
  buttonText?: string | null;
}

const QuoteItem: FC<QuoteItemProps> = ({
  title,
  subtitle,
  isSingleItem = true,
  highLightColor,
  buttonLink,
  buttonText,
}) => {
  const classes = useStyles(isSingleItem, highLightColor)();

  return (
    <div data-testid="quoteItem" className={cx(classes.wrapper, 'quote-item__wrapper')}>
      <Typography data-testid="quoteTitle" className={cx(classes.title, 'quote-item__title')}>
        “&nbsp;{parse(parseHighlightedText(title))}&nbsp;”
      </Typography>
      {subtitle && (
        <>
          <div className={cx(classes.divider, 'quote-item__divider')} />
          <Typography className={cx(classes.subtitle, 'quote-item__subtitle')}>
            {subtitle}
          </Typography>
        </>
      )}
      {buttonText && buttonLink && (
        <a data-testid="quoteLink" href={buttonLink} className={cx(classes.link, classes.btn)}>
          <CustomButton btnClass={classes.btn}>{buttonText}</CustomButton>
        </a>
      )}
    </div>
  );
};

export default QuoteItem;
